<template>
    <van-popup :value="showDiscussDownloadPop" position="bottom" @click-overlay="clickOverlay">
        <div class="discuss-download-note">在聊天中发送或打开新八字请打开APP体验</div>
        <div class="discuss-download-info dsp-flex">
            <div class="discuss-download-logo">
                <img class="discuss-download-logo-img" v-bind:src="logoUrl" alt="木火八字">
                <div class="discuss-download-logo-note">木火八字</div>
            </div>
            <div class="discuss-download-button-box">
                <button class="discuss-download-button" @click="clickOpen">打开</button>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { CONFIG } from '../../modules/config';
import { UA } from '../../modules/utils';
export default {
    name: 'DiscussDownloadPop',
    computed: {
        showDiscussDownloadPop() {
            return this.$store.state.discuss.showDiscussDownloadPop;
        }
    },
    data() {
        return {
            logoUrl: require('../../assets/images/logo-mini.png')
        }
    },
    methods: {
        clickOverlay() {
            this.$store.state.discuss.showDiscussDownloadPop = false;
        },
        clickOpen() {
            console.log('clickOpen-----', UA.isIphone(), UA.isAndroid())
            if(UA.isAndroid()) {
                window.location.href = CONFIG.android_url;
            }else if(UA.isIphone()) {
                window.location.href = CONFIG.ios_url;
            }else {
                this.$toast('请在手机上打开')
            }
        }
    }
}
</script>